import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FrontApiInfoHttpService {
    constructor(private readonly http: HttpClient) {}

    version(): Observable<string> {
        return this.http.get<string>('/info/version', {responseType: 'text' as 'json'})
            .pipe(
                map(version => version && version.replace(/\n/g, ''))
            );
    }
}
